import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { GiConfirmed } from "react-icons/gi";
import { BsWhatsapp } from "react-icons/bs";

const ThankYou = ({ onClose, tname, price }) => {

  ReactPixel.track("Purchase", {
    value: price,
    currency: "INR",
    userName: localStorage.getItem("@userName"),
    email: localStorage.getItem("email"),
    phone: localStorage.getItem("@userPhone"),
    tableName: tname,
  });

  // set timer for 6 sec to close the modal
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 6000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    window.location.reload()

    onClose();
  };

  return (
    <div className="popup-overlay">
      <div className="popup-card">
        <div className="checkmark-circle">
          <span className="checkmark">✓</span>
        </div>

        <h2 style={{ display: 'flex', alignItems: 'center',  gap: '15px' }}>
          Booking confirmed
          <GiConfirmed style={{ color: 'green'}} />
        </h2>


        <p>Your seat for <b>{tname}</b> has been confirmed.
          <br />Please check your inbox for booking details.
        </p>

        {/* <p>
          <b>
            <span className="note-alert">NOTE!</span>: Table details sharing via WhatsApp <BsWhatsapp className="whatsapp-icon" style={{ display: 'inline' }} /> is under maintenance, please check booking details under the "My Bookings" section for all details!
          </b>
        </p> */}

        <button onClick={handleClose}>OK</button>
      </div>
    </div>
  );
};

export default ThankYou;
